import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, ViewChild, inject } from '@angular/core';
import {CommissionSeance} from '../../../interface/api/CommissionSeance';
import {ToolsService} from '../../services/tools/tools.service';
import {Commission} from '../../../interface/api/Commission';
import {HydraService} from '../../../core/services/hydra.service';
import {AideSousType} from '../../../interface/api/AideSousType';
import {Aide} from '../../../interface/api/Aide';
import {FilterValuesContainer} from '../../../interface/FilterValuesContainer';
import {api} from '../../../api/api-dictionnary';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {ExUtilisateur} from '../../../class/ex/ex-utilisateur';
import {CommissionSeanceInterface} from '../../../class/api/CommissionSeance';
import {AideTypeInterface} from '../../../class/api/AideType';
import {MatOptgroup, MatOption} from '@angular/material/core';
import {Subscription} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { KeyValuePipe, NgStyle } from '@angular/common';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatSelect} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';

export class FiltersDossierValues implements FilterValuesContainer {
    public readonly commissionSeance: CommissionSeance;
    public readonly commission: Commission;
    public readonly annees: string[] = [];
    public readonly aideSousTypes: AideSousType[] = [];
    public readonly aides: Aide[];

    constructor(
        annees: string[] = [],
        commission?: Commission,
        commissionSeance?: CommissionSeance,
        aideSousTypes: AideSousType[] = [],
        aides?: Aide[],
    ) {
        this.annees = (annees && annees.length) ? annees : [];
        this.commission = (commission) ? commission : null;
        this.commissionSeance = (commissionSeance) ? commissionSeance : null;
        this.aideSousTypes = (aideSousTypes) ? aideSousTypes : [];
        this.aides = (aides) ? aides : [];
    }

    getFilters(): { key: string; value: string; }[] {
        const filters = [];

        this.aideSousTypes.forEach(element => {
            if (element) {
                filters.push(
                    {
                        key: 'aide.aideSousType[]',
                        value: element.id.toString()
                    }
                );
            }
        });

        this.aides.forEach(element => {
            filters.push(
                {
                    key: 'aide[]',
                    value: element.id.toString()
                }
            );
        });

        if (this.commissionSeance) {
            filters.push(
                {
                    key: 'commissionSeances[]',
                    value: this.commissionSeance.id.toString()
                }
            );
        }

        if (this.commission) {
            filters.push(
                {
                    key: 'commissionSeances.commission[]',
                    value: this.commission.id.toString()
                }
            );
        }

        this.annees.forEach(element => {
            filters.push(
                {
                    key: 'aide.annee[]',
                    value: element
                }
            );
        });

        return filters;
    }

    applyFilters(url: URL, context?: any): URL {

        const prefixFiltersApiExpert: string = (context && context.resource === api.dossierExpert) ? 'dossier.' : '';

        this.getFilters().forEach(
            filter => {
                url.searchParams.append(prefixFiltersApiExpert + filter.key, filter.value);
            }
        )

        return url;
    }
}

interface AideSousTypesGroupedByAideType {
    [aideTypeIRI: string]: {
        aideType: AideTypeInterface;
        aideSousTypes: AideSousType[];
    };
}

@Component({
    selector: 'app-filters-dossier',
    templateUrl: './filters-dossier.component.html',
    styleUrls: ['./filters-dossier.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatButton, MatOptgroup, NgStyle, MatTooltip, MatIcon, KeyValuePipe, TranslateModule]
})
export class FiltersDossierComponent implements AfterViewInit, OnDestroy {
    toolService = inject(ToolsService);
    hydraService = inject(HydraService);
    private changeDetector = inject(ChangeDetectorRef);
    private authentificationService = inject(AuthentificationService);
    private translateService = inject(TranslateService);


    private connecteduser: ExUtilisateur;
    public subscriptions: Subscription[] = [];
    public messageReinitFiltre = 'front.filterDossier.reinitialiserFiltres';

    constructor() {
        this.connecteduser = new ExUtilisateur(this.authentificationService.userConnected);
        this.getTranslations();
    }

    @ViewChild('allSousType') private allSousType: MatOption;

    @Output('onChange') filtersValues = new EventEmitter<FiltersDossierValues>();

    @Output('aidesList') aidesList = new EventEmitter<Aide[]>();
    @Output('commissionSeanceList') commissionSeanceList = new EventEmitter<CommissionSeance[]>();

    @Input() displayAnnees = true;
    @Input() displayInstance = true;
    @Input() displayReunion = true;
    @Input() hideCommissionsNonDecisives = false;
    @Input() multipleAides = true;

    @Input() cascadeAapFromInstances = true;

    @Input() filterCommissionSeancesForMe: 'mandats' | 'mandatsActifs' | 'nominations' | 'allForMe' = 'allForMe';

    @Input('filtersDossierValues') set defaultValue(item: FiltersDossierValues) {
        if (item) {
            this.anneesSelected = (item.annees) ? item.annees : [];
            this.commissionSeanceSelected = (item.commissionSeance) ? item.commissionSeance : null;
            this.commissionSelected = (item.commission) ? item.commission : null;
            this.aideSousTypesSelected = (item.aideSousTypes) ? item.aideSousTypes : [];
            this.aideSelected = (item.aides) ? item.aides : [];
        }
    }

    anneesSelected: string[] = [];
    annees: string[] = [];

    commissionSeanceSelected: CommissionSeance | null = null;
    commissionSeances: CommissionSeance[] = [];
    commissionSeancesFiltered: CommissionSeance[] = [];

    commissionSelected: Commission | null = null;
    commissions: Commission[] = [];
    commissionsFiltered: Commission[] = [];

    aideSousTypesSelected: AideSousType[] = [];
    aideSousTypes: AideSousType[] = [];
    aideSousTypesFiltered: AideSousTypesGroupedByAideType = {};

    aideSelected: Aide[] = [];
    aides: Aide[] = [];
    aidesFiltered: Aide[] = [];

    public getTranslations() {
        this.subscriptions.push(this.translateService.get(this.messageReinitFiltre).subscribe(res => this.messageReinitFiltre = res));
    }

    ngAfterViewInit() {
        this.initFiltreAnnees();
        this.loadCommissionSeances();
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }

    private initFiltreAnnees() {
        this.annees = FiltersDossierComponent.getAnnees();

        if (!this.displayAnnees) {
            this.anneesSelected = [...this.annees];
            return;
        }

        if (this.anneesSelected.length === 0) {
            const now = new Date();
            const year = now.getFullYear() + '';
            this.anneesSelected.push(year);

            const currentMonth = now.getMonth();
            const monthUntilWeShowLastYear = 5;

            const additionalYearTerm = (currentMonth <= monthUntilWeShowLastYear) ? -1 : 1;
            const additionalYear = (parseInt(year) + additionalYearTerm).toString();
            this.anneesSelected.push(additionalYear);
            this.outputValues();
        }

    }

    public anneesSelectedChanged() {
        this.filterCommissionSeances();
        this.filterCommissions();
        this.filterAides();
        this.filterAideSousTypes();
        this.outputValues();
    }

    public commissionSelectedChanged() {
        this.filterCommissionSeances();
        this.filterAides();
        this.filterAideSousTypes();
        this.outputValues();
    }

    public aideSelectedChanged() {
        this.outputValues();
    }

    public aideSousTypesSelectedChanged() {
        this.filterAides();
        this.outputValues();
    }

    public commissionSeanceSelectedChanged() {
        this.filterAides();
        this.filterAideSousTypes();
        this.outputValues();
    }

    public resetSousType() {
        this.aideSousTypesSelected = [];
        this.aideSousTypesSelectedChanged();
    }

    public resetAAP() {
        this.aideSelected = [];
        this.aideSelectedChanged();
    }

    public resetFilters() {
        this.anneesSelected = [];
        this.commissionSelected = null;
        this.commissionSeanceSelected = null;
        this.aideSousTypesSelected = [];
        this.aideSelected = [];
        this.initFiltreAnnees();
        this.anneesSelectedChanged();
    }


    public static getAnnees(): string[] {
        const nextYear = new Date().getFullYear() + 1;
        const annees: string[] = [];
        for (let year = nextYear; year > nextYear - 15; year--) {
            annees.push(year.toString());
        }
        return annees;
    }

    private loadCommissionSeances(): void {
        if (!this.displayReunion) {
            this.loadCommissions();
            return;
        }

        let url: string = api.commissionSeances + '?pagination=false';

        if (!this.authentificationService.hasRoleDataVis()) {
            if (this.filterCommissionSeancesForMe) {
                url += '&forMe=' + this.filterCommissionSeancesForMe;
            } else {
                url += '&forMe=allForMe';
            }
        }

        this.hydraService.getList(url).subscribe(res => {

            let commissionSeances: CommissionSeanceInterface[] = res.getMember();

            if (this.hideCommissionsNonDecisives) {
                commissionSeances = commissionSeances.filter(elem => elem.decisiveStatutDossier || elem.commission.code == 'CS' || elem.commission.code == 'ADHOC');
            }

            this.commissionSeances = this.commissionSeancesFiltered = commissionSeances;

            if (this.commissionSeanceSelected) { // Ré-écriture de la référence Javascript
                this.commissionSeanceSelected = this.commissionSeances.find(item => item.id == this.commissionSeanceSelected.id);
            }

            this.loadCommissions();

            this.commissionSeanceList.emit(commissionSeances);
        });
    }

    private loadCommissions(): void {
        if (!this.displayInstance) {
            this.loadAideSousTypes();
            return;
        }

        this.toolService.getCommissions().subscribe(res => {
            let commissions = res.getMember();

            if (this.hideCommissionsNonDecisives) {
                commissions = commissions.filter(elem => elem.commissionType.code != 'CN');
                this.commissionsFiltered = this.commissions;
            }

            this.commissions = this.commissionsFiltered = commissions;

            if (this.commissionSelected) { // Ré-écriture de la référence Javascript
                this.commissionSelected = this.commissions.find(item => item.id == this.commissionSelected.id);
            }
            this.loadAideSousTypes();
        });
    }

    private loadAideSousTypes() {
        this.toolService.getAideSousTypes().subscribe(
            res => {
                this.aideSousTypes = res.getMember();
                this.aideSousTypesFiltered = this.grouperAIdeSousTypesParAideType(res.getMember());
                if (this.aideSousTypesSelected) { // Ré-écriture de la référence Javascript
                    const idsMap = this.aideSousTypesSelected.map(item => item['id']);
                    this.aideSousTypesSelected = this.aideSousTypes.filter(
                        item => idsMap.includes(item.id)
                    );
                }
                this.loadAides();
            }
        );
    }

    private loadAides() {
        this.hydraService.getList(
            api.aides + '?pagination=false'
            + '&workflowCommissionsComplet=1'
            + '&replaceGroups[]=AideMinimal'
            + '&replaceGroups[]=UtilisateurMinimal'
            + '&replaceGroups[]=AideAideSousType'
            + '&replaceGroups[]=AideSousTypeMinimalRead'
            + '&replaceGroups[]=ReunionsHorsWorkflow'
            + '&order[label]=desc'
        ).subscribe(res => {
            this.aides = res.getMember();
            this.aidesFiltered = res.getMember();
            if (this.aideSelected) { // Ré-écriture de la référence Javascript
                //this.aideSelected = this.aides.find(item => item.id == this.aideSelected.id)
                const idsMap = this.aideSelected.map(item => item['id']);
                this.aideSelected = this.aides.filter(
                    item => idsMap.includes(item.id)
                );
            }
            this.filtersUpdate();
            this.aidesList.emit(this.aides);
        });
    }

    public filtersUpdate() {
        this.filterCommissionSeances();
        this.filterCommissions();
        this.filterAides();
        this.filterAideSousTypes();
    }

    private filterCommissionSeances(): void {
        this.commissionSeancesFiltered = this.getCommissionSeancesFiltered(
            new FiltersDossierValues(
                this.anneesSelected,
                this.commissionSelected,
                null,
                this.aideSousTypesSelected,
                this.aideSelected
            )
        );
        this.ensureCommissionSeanceSelectedCompatible();
    }

    private filterCommissions(): void {
        this.commissionsFiltered = this.commissions.filter(
            commission => this.assertCommissionCompatible(commission)
        );
        this.ensureCommissionSelectedCompatible();
    }

    private filterAides(): void {

        const constraints = new FiltersDossierValues(
            this.anneesSelected,
            this.commissionSelected,
            this.commissionSeanceSelected,
            this.aideSousTypesSelected,
            null
        );

        this.aidesFiltered = this.getAidesFiltered(
            constraints
        );

        this.ensureAideSelectedCompatible(constraints);
    }

    private filterAideSousTypes() {
        const constraints = new FiltersDossierValues(
            this.anneesSelected,
            this.commissionSelected,
            this.commissionSeanceSelected,
            null,
            this.aidesFiltered
        );

        this.aideSousTypesFiltered = this.grouperAIdeSousTypesParAideType(this.aideSousTypes.filter(
            aideSousType => this.assertAideSousTypeCompatible(aideSousType, constraints)
        ));

        this.ensureaideSousTypesSelectedCompatible(constraints);
    }

    private static assertCommissionSeanceCompatible(
        commissionSeance: CommissionSeance,
        filtersDossierValues: FiltersDossierValues
    ): boolean {
        const dateTimeDebutString = commissionSeance.datetimeDebut;
        if (!dateTimeDebutString) {
            return false;
        }

        if (!filtersDossierValues.annees.includes(
            new Date(dateTimeDebutString).getFullYear().toString()
        )) {
            return false;
        }

        const commissionSelected = filtersDossierValues.commission;
        if (!commissionSelected) {
            return true;
        }

        return HydraService.assertItemsAreSameResource(
            commissionSeance.commission,
            commissionSelected
        );
    }

    private assertAideCompatible(aide: Aide, filtersDossierValues: FiltersDossierValues): boolean {

        const anneeAAP = aide.annee;
        if (anneeAAP && !filtersDossierValues.annees.includes(
            anneeAAP.toString()
        )) {
            return false;
        }

        const currentaideSousTypesSelected = filtersDossierValues.aideSousTypes;
        if (currentaideSousTypesSelected && currentaideSousTypesSelected.length) {
            const res = currentaideSousTypesSelected.find(
                elt => HydraService.assertItemsAreSameResource(elt, aide.aideSousType)
            );
            if (!res) {
                return false;
            }
        }

        if (!this.cascadeAapFromInstances) {
            return true;
        }


        const currentCommissionSeanceSelected = filtersDossierValues.commissionSeance;
        if (currentCommissionSeanceSelected) {
            const res = currentCommissionSeanceSelected.aides.find(
                test => HydraService.assertItemsAreSameResource(test, aide)
            );
            if (res) {
                return true;
            }

            return (aide['reunionsHorsWorkflow'] ?? []).find(
                test => HydraService.assertItemsAreSameResource(test, currentCommissionSeanceSelected)
            ) !== undefined;
        }

        if (this.commissionSeancesFiltered.length) {
            const res = this.commissionSeancesFiltered.find(
                cs => cs.aides.find(
                    test => HydraService.assertItemsAreSameResource(test, aide)
                )
            );
            if (res) {
                return true;
            }

            const reunionsHorsWorkflowIris = (aide['reunionsHorsWorkflow'] ?? []).map(reunion => HydraService.extractIRI(reunion));
            const commissionSeancesFiltered = this.commissionSeancesFiltered.map(reunion => HydraService.extractIRI(reunion));

            return reunionsHorsWorkflowIris.find(item => commissionSeancesFiltered.includes(item)) !== undefined;
        }

        return true;
    }

    private assertAideSousTypeCompatible(aideSousType: AideSousType, filtersDossierValues: FiltersDossierValues) {
        if (filtersDossierValues.annees.length === 0) {
            return true;
        }

        return -1 !== this.getAidesFiltered(
            new FiltersDossierValues(
                filtersDossierValues.annees,
                filtersDossierValues.commission,
                filtersDossierValues.commissionSeance,
                null,
                null
            )
        ).findIndex(
            aide => HydraService.assertItemsAreSameResource(
                aide.aideSousType,
                aideSousType
            )
        );

    }

    private assertCommissionCompatible(commission: Commission): boolean {
        return -1 !== this.getCommissionSeancesFiltered(
            new FiltersDossierValues(
                this.anneesSelected,
                null,
                null,
                this.aideSousTypesSelected,
                this.aideSelected
            )
        ).findIndex(
            commissionSeance => HydraService.assertItemsAreSameResource(
                commissionSeance.commission,
                commission
            )
        );
    }

    private ensureCommissionSeanceSelectedCompatible(): void {
        const currentCommissionSeanceSelected = this.commissionSeanceSelected;
        if (!currentCommissionSeanceSelected) {
            return;
        }
        if (!FiltersDossierComponent.assertCommissionSeanceCompatible(
            currentCommissionSeanceSelected,
            new FiltersDossierValues(
                this.anneesSelected,
                this.commissionSelected,
                null,
                this.aideSousTypesSelected,
                this.aideSelected
            )
        )
        ) {
            this.commissionSeanceSelected = null;
            this.commissionSeanceSelectedChanged();
        }
    }

    private ensureCommissionSelectedCompatible(): void {
        const currentCommissionSelected = this.commissionSelected;
        if (!currentCommissionSelected) {
            return;
        }
        if (!this.assertCommissionCompatible(currentCommissionSelected)) {
            this.commissionSelected = null;
            this.commissionSelectedChanged();
        }
    }

    private ensureAideSelectedCompatible(constraints: FiltersDossierValues) {
        const currentAideSelected = this.aideSelected;
        if (!currentAideSelected) {
            return;
        }

        this.aideSelected.forEach(
            item => {
                if (!this.assertAideCompatible(
                    item,
                    constraints
                )
                ) {
                    this.aideSelected = this.aideSelected.filter(obj => obj !== item);
                    this.aideSelectedChanged();
                }
            }
        );

    }

    private ensureaideSousTypesSelectedCompatible(constraints: FiltersDossierValues) {
        const currentaideSousTypesSelected = this.aideSousTypesSelected;
        if (!currentaideSousTypesSelected) {
            return;
        }

        this.aideSousTypesSelected.forEach(
            item => {
                if (!this.assertAideSousTypeCompatible(
                    item,
                    constraints
                )
                ) {
                    this.aideSousTypesSelected = this.aideSousTypesSelected.filter(obj => obj !== item);
                    this.aideSousTypesSelectedChanged();
                }
            }
        );

    }

    private outputValues(): void {
        if (!Array.isArray(this.aideSelected)) {
            this.aideSelected = new Array(this.aideSelected);
        }

        this.filtersValues.emit(
            new FiltersDossierValues(
                this.anneesSelected,
                this.commissionSelected,
                this.commissionSeanceSelected,
                this.aideSousTypesSelected,
                this.aideSelected
            )
        );
    }

    private getAidesFiltered(filtersDossierValues: FiltersDossierValues): Aide[] {
        return this.aides.filter(
            aide => this.assertAideCompatible(aide, filtersDossierValues)
        );
    }

    private getCommissionSeancesFiltered(filtersDossierValues: FiltersDossierValues): CommissionSeance[] {
        return this.commissionSeances.filter(
            commissionSeance => FiltersDossierComponent.assertCommissionSeanceCompatible(
                commissionSeance,
                filtersDossierValues
            )
        );
    }

    private grouperAIdeSousTypesParAideType(aideSousTypes: AideSousType[]): AideSousTypesGroupedByAideType {
        return aideSousTypes.reduce(
            (acc, cur, index) => {
                const aideType = cur.aideType as AideTypeInterface;
                const key: string = aideType['@id'] ?? 'unknown';
                if (!acc[key]) {
                    acc[key] = {
                        aideType,
                        aideSousTypes: [cur]
                    };
                } else {
                    acc[key].aideSousTypes.push(cur);
                }
                return acc;
            }, {} as AideSousTypesGroupedByAideType);
    }

    isAideFilterDisabled() {
        return (this.aideSelected?.length ?? 0) === 0
            && !this.commissionSeanceSelected
            && (
                (this.anneesSelected.length === 0 && this.displayAnnees) ||
                (this.aideSousTypesSelected.length === 0 && !this.displayAnnees)
            )
    }
}
